import {
  FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST,
  FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS,
  FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE,
} from '~/common/redux/types';

const initialState = {
  data: [],
  status: {
    isFetching: false,
    isFetched: false,
    error: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_E_SIGN_DOCUMENT_SUMMARY_REQUEST:
      return {
        ...initialState,
        status: {
          ...initialState.status,
          isFetching: true,
        },
      };
    case FETCH_E_SIGN_DOCUMENT_SUMMARY_SUCCESS:
      return {
        data: action.payload,
        status: {
          isFetching: false,
          isFetched: true,
          error: false,
        },
      };
    case FETCH_E_SIGN_DOCUMENT_SUMMARY_FAILURE:
      return {
        ...initialState,
        status: {
          isFetching: false,
          isFetched: true,
          error: true,
        },
      };
    default:
      return state;
  }
};
